module.exports = __webpack_public_path__ + "static/media/pos_blog_3.57dcf0ed.png";